import React, { PropsWithChildren } from "react";
import { generateClassName } from "../../../hooks/useAttributes";
import "./Pill.css";
import { getTextColorFromBackground } from "../../../util/util";
import IElementProps from "../../../types/ElementProps";

interface Props<T extends string> extends IElementProps {
  onClick?: () => void,
  round?: boolean;
  valueLabelMap?: Record<T, string>,
  size?: "small" | "regular";
  background?: string;
  foreground?: string;
  border?: string;
  value?: T
}

export default function Pill<T extends string>(props: PropsWithChildren<Props<T>>) {

  const {
    children,
    background,
    className,
    foreground,
    border,
    value,
    round,
    valueLabelMap,
    size = "regular"
  } = props;

  const content = children ?? (value && valueLabelMap ? valueLabelMap[value] : value);

  const bg = background ?? "var(--primaryAccent)";
  const fg = foreground ?? getTextColorFromBackground(bg);

  return (
    <div
      onClick={props.onClick}
      className={generateClassName(className, `badge badge-pill pill pill-size-${size}`, {
        value: round,
        onTrue: "rounded-pill"
      })}
      style={{
        width: "fit-content",
        backgroundColor: bg,
        color: fg,
        border,
      }}
    >
      {content}
    </div>
  )
}